import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import useRemoveHash from '../../utils/router/useRemoveHash';
import commentThreadHash from '../../utils/url/commentThreadHash';

const THREAD_FRAGMENT = gql(`
  fragment useResolveThread_thread on RootThreadFields {
    id
  }
`);

const RESOLVE_THREAD_MUTATION = gql(/** @complexity 2 */ `
  mutation resolveThread($id: ID!) {
    resolveThread(threadId: $id) {
      id
      resolvedAt
    }
  }
`);

const useResolveThread = (thread: DocumentType<typeof THREAD_FRAGMENT>) => {
  const removeHash = useRemoveHash();

  const [mutation] = useMutation(RESOLVE_THREAD_MUTATION, {
    variables: { id: thread.id },
    optimisticResponse: {
      resolveThread: {
        __typename: thread.__typename,
        id: thread.id,
        resolvedAt: new Date().toISOString(),
      },
    },
  });

  return useCallback(async () => {
    await mutation();
    if (window.location.hash === commentThreadHash(thread.id)) {
      removeHash();
    }
  }, [mutation, removeHash, thread.id]);
};

export default useResolveThread;
